import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import './markers.css';

const markers = {
"type": "FeatureCollection",
"features": [
{ "type": "Feature", "properties": { "Name": "Port-a-John", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.4557299, 42.258274, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-John", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.4190601, 42.2758848, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.3817412, 42.2826629, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.2825128, 42.3051262, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.1976987, 42.337781, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.2256339, 42.3377929, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.3150132, 42.2953657, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.3489418, 42.283417, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.4068949, 42.2787297, 0.0 ] } },
{ "type": "Feature", "properties": { "Name": "Port-a-Johns", "description": null, "timestamp": null, "begin": null, "end": null, "altitudeMode": null, "tessellate": -1, "extrude": -1, "visibility": -1, "drawOrder": null, "icon": null }, "geometry": { "type": "Point", "coordinates": [ -71.47255, 42.2508808, 0.0 ] } }
]
}

function addMarkers(map) {
  markers.features.forEach(function(marker, i) {
    // add markers for stops
    const markerHeight = 18;
    const markerRadius = markerHeight / 2;
    var popupOffsets = {
      'bottom': [0, -markerRadius],
    };

    var el = document.createElement('div');
    el.className = 'toilet route-markers';
    el.style.height = 20 + 'px';
    el.style.width = 20 + 'px';

    const popup = new mapboxgl.Popup({anchor: 'bottom', offset: popupOffsets})
    .setHTML(`
      <div class="popup-body">
        Public restroom
      </div>
    `);

    new mapboxgl.Marker(el, {offset:
      [-10, -10]})
      .setLngLat(marker.geometry.coordinates.slice(0, 2))
      .setPopup(popup)
      .addTo(map);
  });
}

const Toilets = {
  addMarkers: addMarkers,
};

export default Toilets;



// WEBPACK FOOTER //
// ./src/geojson/Toilets.js